if (!customElements.get('le-reviews')) customElements.define('le-reviews', class extends HTMLElement {
  connectedCallback() {
    if (this.abort) return;
    this.abort = new AbortController();
    const options = { signal: this.abort.signal };
    this.track = this.querySelector('.reviews-track');
    this.cards = [...this.querySelectorAll('.review-card')];
    this.dots = [...this.querySelectorAll('[data-review-dot]')];
    this.controls = this.querySelector('.reviews-controls');
    this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
    this.current = 0;
    this.hovered = false;
    this.focused = false;
    this.visible = false;
    this.auto = this.dataset.auto === 'true';
    this.pauseOnHover = this.dataset.pauseOnHover === 'true';

    if (this.cards.length < 2) return;
    this.controls?.removeAttribute('hidden');

    this.show = index => {
      this.current = (index + this.cards.length) % this.cards.length;
      this.cards.forEach((card, i) => {
        const active = i === this.current;
        card.toggleAttribute('data-review-active', active);
        card.inert = !active;
        if (active) card.removeAttribute('aria-hidden');
        else card.setAttribute('aria-hidden', 'true');
      });
      this.dots.forEach((dot, i) => {
        if (i === this.current) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    };

    this.stop = () => { clearInterval(this.timer); this.timer = null; };
    this.start = () => {
      this.stop();
      if (!this.auto || this.reduced.matches || (this.pauseOnHover && this.hovered) || this.focused || !this.visible || document.hidden) return;
      this.timer = setInterval(() => this.show(this.current + 1), Number(this.dataset.interval || 6) * 1000);
    };
    this.select = index => {
      this.show(index);
      this.start();
    };

    this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.select(i), options));
    this.track.addEventListener('keydown', event => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      this.select(this.current + (event.key === 'ArrowRight' ? 1 : -1));
    }, options);
    let touchX = 0;
    let touchY = 0;
    this.track.addEventListener('touchstart', event => {
      touchX = event.changedTouches[0].clientX;
      touchY = event.changedTouches[0].clientY;
    }, { ...options, passive: true });
    this.track.addEventListener('touchend', event => {
      const dx = event.changedTouches[0].clientX - touchX;
      const dy = event.changedTouches[0].clientY - touchY;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) this.select(this.current + (dx < 0 ? 1 : -1));
    }, { ...options, passive: true });
    this.addEventListener('pointerenter', event => {
      if (event.pointerType === 'mouse') { this.hovered = true; if (this.pauseOnHover) this.stop(); }
    }, options);
    this.addEventListener('pointerleave', () => { this.hovered = false; this.start(); }, options);
    this.addEventListener('focusin', event => {
      if (event.target.matches(':focus-visible')) { this.focused = true; this.stop(); }
    }, options);
    this.addEventListener('focusout', event => {
      if (!this.contains(event.relatedTarget) || !event.relatedTarget.matches(':focus-visible')) { this.focused = false; this.start(); }
    }, options);
    this.addEventListener('shopify:block:select', event => {
      const index = this.cards.indexOf(event.target.closest('.review-card'));
      if (index >= 0) this.select(index);
    }, options);
    document.addEventListener('visibilitychange', () => this.start(), options);
    this.reduced.addEventListener('change', () => this.start(), options);
    this.observer = new IntersectionObserver(entries => {
      this.visible = entries[0].isIntersecting;
      this.start();
    }, { threshold: 0.05 });
    this.observer.observe(this);
    this.show(0);
  }

  disconnectedCallback() {
    this.stop?.();
    this.abort?.abort();
    this.abort = null;
    this.observer?.disconnect();
  }
});
